import { FormikHelpers } from 'formik';
import * as Yup from 'yup';
import YupPassword from 'yup-password';

import { regexMobilePhone } from 'src/constants';
import { FormikInputPasswordValidation } from 'src/general/components/forms/FormikInput/FormikInputPassword';
import { getRegexForm } from 'src/utils/utils';

YupPassword(Yup); // extend yup

export interface FormProps<T> {
  /**
   * Handle form submission
   * @returns true if successful, string with error message otherwise
   */
  onSubmit: (values: T, formikHelpers: FormikHelpers<T>) => Promise<true | string>;
  onSubmitTracking?: (success: boolean, reasons?: string[]) => void;
  onBack?: () => void;
}

export const EmailFormValidation = Yup.object({
  email: Yup.string().email().required(),
});

export type EmailFormValues = ReturnType<typeof EmailFormValidation.validateSync>;

const phoneError = 'Please enter a valid Australian mobile number';

export const SignupPersonalDetailsFormValidation = Yup.object({
  firstName: Yup.string().required('Please enter a first name').matches(getRegexForm.nameRegex),
  lastName: Yup.string().required('Please enter a last name').matches(getRegexForm.nameRegex),
  phone: Yup.string().required(phoneError).matches(regexMobilePhone, phoneError),
  newPassword: FormikInputPasswordValidation,
  marketing: Yup.lazy((value) => (typeof value === 'boolean' ? Yup.boolean() : Yup.string())),
});

export type SignupPersonalDetailsFormValues = ReturnType<typeof SignupPersonalDetailsFormValidation.validateSync>;

export const SigninFormValidation = Yup.object({
  password: Yup.string().required('A password is required'),
});

export type SigninFormValues = ReturnType<typeof SigninFormValidation.validateSync>;

const VerificationTokenFormValidation = Yup.object({
  verificationCode: Yup.string()
    .required('A verification code is required')
    .length(4, 'The verification code must be 4 digits'),
});

export type VerificationTokenFormValues = ReturnType<typeof VerificationTokenFormValidation.validateSync>;

export const ResetPasswordFormValidation = Yup.object({
  email: Yup.string().email().required(),
});

export type ResetPasswordFormValues = ReturnType<typeof ResetPasswordFormValidation.validateSync>;

export const ResendPasswordFormValidation = Yup.object({});

export type ResendPasswordFormValues = ReturnType<typeof ResendPasswordFormValidation.validateSync>;

export const NewPasswordFormValidation = Yup.object({
  newPassword: FormikInputPasswordValidation,
});

export type NewPasswordFormValues = ReturnType<typeof NewPasswordFormValidation.validateSync>;

export const ConfirmDetailsFormValidation = Yup.object({
  firstName: Yup.string().required('Please enter a first name').matches(getRegexForm.nameRegex),
  lastName: Yup.string().required('Please enter a last name').matches(getRegexForm.nameRegex),
  marketing: Yup.lazy((value) => (typeof value === 'boolean' ? Yup.boolean() : Yup.string())),
});

export type ConfirmDetailsFormValues = ReturnType<typeof ConfirmDetailsFormValidation.validateSync>;
